const baseNewsUrl = "New"
  const endpoints = {
   
    getNewsDetails:`${baseNewsUrl}`,
   
   
  };
  
  export default endpoints;
  